import { useState, useCallback } from 'react';

export function useLoading() {
  const [loadingProcesses, setLoadingProcesses] = useState([]);

  const addProcess = useCallback((processName) => {
    setLoadingProcesses((prevProcesses) => [...prevProcesses, processName]);
  }, []);

  const removeProcess = useCallback((processName) => {
    setLoadingProcesses((prevProcesses) => prevProcesses.filter((process) => process !== processName));
  }, []);

  const isLoading = useCallback(() => loadingProcesses.length > 0, [loadingProcesses]);

  const processExists = useCallback((processName) => loadingProcesses.includes(processName), [loadingProcesses]);

  return {
    addProcess,
    removeProcess,
    isLoading,
    processExists,
  };
}
